import apiClient from '../../lib/axios';

export const fetchCurrencies = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/currency-types?${params.toString()}`);
  return data;
};

export const fetchActiveCurrencies = async () => {
  const { data } = await apiClient.get('/api/currency-types/active');
  return data;
};

export const createCurrency = async (payload) => {
  const { data } = await apiClient.post('/api/currency-types', payload);
  return data;
};

export const updateCurrency = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/currency-types/${id}`, payload);
  return data;
};

export const deleteCurrency = async (id) => {
  const { data } = await apiClient.delete(`/api/currency-types/${id}`);
  return data;
};

export default fetchCurrencies;
